import api from '../api/user/UserUserReq';
import { toast } from 'sonner';
import { useState } from 'react';
import '../styles/main.css';
import { FaUser } from 'react-icons/fa';
import { RiLockPasswordLine } from "react-icons/ri";
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthProvider';


const Login = () => {

    const [loginn, setLogin] = useState('');
    const [password, setPassword] = useState('');
    const navigate = useNavigate();

    const { login, logout } = useAuth();

    const handleLogin = async (e) => {
        e.preventDefault();
        try {
          const response = await api.post('login', {
            username: loginn,
            password: password
          }, {withCredentials: true});

          if (response.data.success) {
            login();
            toast.success('Successfully logged in!')
            navigate('/menu');
          } else {
            console.log(response.data);
            logout();
            toast.error('Failure! Wrong credentials!')
            navigate('/flexp-login');
          }

        } catch (error) {
          console.log(error)
        }

        
    }

    return (
        <div className='login-container'>
          <div className='login-card'>
            <h2 className='login-title'>Login</h2>
            <form className="login-form" onSubmit={handleLogin}>
              <div className='login-input-group'>
                <label htmlFor="login" className='login-label'>Username</label>
                <div className='login-input-wrapper'>
                    <input
                    type="login"
                    id="login"
                    className='login-input'
                    value={loginn}
                    onChange={(e) => setLogin(e.target.value)}
                    required
                    />
                    <FaUser className='login-icon'/>
                </div>
                
              </div>
              <div className='login-input-group'>
                <label htmlFor="password" className='login-label'>Password</label>
                <div className='login-input-wrapper'>
                    <input
                    type="password"
                    id="password"
                    className='login-input'
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    />
                    <RiLockPasswordLine className='login-icon'/>
                </div> 
              </div>
              <button type="submit" className='login-button'>Login</button>
            </form>
          </div>
        </div>
      );
    };

export default Login;